<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <div class="cleanmap">
          <h2>Impressum</h2>
          <p>Christian Huder<br>
            Rudolfstraße 10<br>
            10245 Berlin</p>

          <h3>Contact</h3>
          <p>email: hello@innergy.berlin<br>
            phone: (49) 3068322626</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    methods: {
      back () {
        window.history.go(-1)
      }},
    data: function () {
      return {
        title: 'Impressum'
      }
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: [
        { name: 'description', content: 'My description', id: 'desc' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Impressum.vue?efc69ec4